import { useEffect, useRef } from "react";

import { areSectionOrdersEqual } from "./JobSwmsFormV3SectionRegistry.utils";

export default function useJobSwmsFormV3SectionSequenceSync({
  swmsData,
  orderedSectionKeys,
  activeSectionKeys = [],
  fixedSectionCount = 0,
  sectionsMap,
  change
}) {
  const lastSyncedOrderRef = useRef([]);
  const metaSequence = swmsData && swmsData.meta && swmsData.meta.sequence ? swmsData.meta.sequence : {};
  const existingFixedSequence = Array.isArray(metaSequence.fixed) ? metaSequence.fixed : [];
  const existingActiveSequence = Array.isArray(metaSequence.active) ? metaSequence.active : [];

  useEffect(() => {
    if (typeof change !== "function" || orderedSectionKeys.length === 0) {
      return;
    }

    if (areSectionOrdersEqual(lastSyncedOrderRef.current, orderedSectionKeys)) {
      return;
    }

    lastSyncedOrderRef.current = [...orderedSectionKeys];
  }, [activeSectionKeys, change, existingActiveSequence, existingFixedSequence, orderedSectionKeys, sectionsMap]);
}